
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, feedProductType} from "../../../../comman/config";
import Loader from "../../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import * as XLSX from 'xlsx';

function List() {

    const [feedList, setFeedList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');
    

    const navigate = useNavigate();

    useEffect(() => {
        getFeedCompanyList();
        getProductList();
    }, []);

    useEffect(() => {
        getFeedList();
        
    }, [page, fromDate,toDate,name]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const getFeedList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/feed/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setFeedList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const deleteFeed = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/farm/feed/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

    const getFeedCompanyList = async () => {
        setPopupOpen(true);
        const condition = `company_type = 1 AND (product_type =  2 OR product_type = 3) AND status = 1`;
        const response = await axios.get(`${baseUrl}/admin/profile/company/company_list?condition=${condition}`);
        setCompanyList(response.data.data);
        setPopupOpen(false);
    }

    const getProductList = async ()=> {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/profile/product/list_all`);
        setPopupOpen(false);
        setProductList(response.data.data);
    }

    const editFeed = async (id) => {
        navigate(`/admin/farm/feed/edit/${btoa(id)}`, { state: feedList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate);  
        setName(name);
    };

    const companyName = (type) => {
       
        return companyList.find((val) => val.id == type)?.name ?? "";
    }

    const productName = (product) => {
        return productList.find((val) => val.id == product)?.name ?? "";
    }
   
    const exportToExcel = async () => {
        try {
            setPopupOpen(true);
    
            // Fetch all filtered feed list (large limit to get full data)
            const response = await axios.get(`${baseUrl}/admin/farm/feed/list?page=1&limit=10000&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
            const exportList = response.data.data;
    
            // Resolve company/product names before mapping
            const data = exportList.map(item => ({
                Date: item.date,
                "Company Name": companyList.find(c => c.id === item.company_id)?.name ?? '',
                "Product Type": feedProductType.find(t => t.value === item.product_type)?.label ?? '',
                "Product Name": productName(item.product_name),
                "Product Quantity": item.product_quantity,
                "Product Price": item.product_price
            }));
    
            // Optional: Add total row
            const totalPrice = data.reduce((sum, row) => sum + parseFloat(row["Product Price"] || 0), 0);
            data.push({
                Date: '',
                "Company Name": '',
                "Product Type": '',
                "Product Name": 'Total',
                "Product Quantity": '',
                "Product Price": totalPrice.toFixed(2)
            });
    
            // Create Excel sheet
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Feed List");
            XLSX.writeFile(workbook, "Feed_List.xlsx");
    
            setPopupOpen(false);
        } catch (error) {
            console.error('Excel Export Error:', error);
            setPopupOpen(false);
        }
    };
    


    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Feed List</h1>
                <div>
                <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-green-700 text-white rounded-md mr-2 hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
        >
            Export to Excel
        </button>
                    <Link to="/admin/farm/feed/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Feed</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Company Name</th>
                        <th scope="col" className="px-6 py-3 border">Product Type</th>
                        <th scope="col" className="px-6 py-3 border">Product Name</th>
                        <th scope="col" className="px-6 py-3 border">Product Quantity</th>
                        <th scope="col" className="px-6 py-3 border">Product Price</th>
                        <th scope="col" className="px-6 py-3 border">Action</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {feedList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{companyName(item.company_id)}</td>
                            <td className="px-6 py-4">{feedProductType.find((val) => val.value == item.product_type)?.label ?? ""}</td>
                            <td className="px-6 py-4">{productName(item.product_name)}</td>
                            <td className="px-6 py-4">{item.product_quantity}</td>
                            <td className="px-6 py-4">{item.product_price}</td>
                            <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editFeed(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" /> {/* Edit icon */}
                                    </a>
                                    <a href="#" onClick={() => deleteFeed(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
        </div>
  );
}

export default List;